// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__DtbhA","icon":"SortAdornment_icon__WG-QL","up":"SortAdornment_up__WjrZE","down":"SortAdornment_down__22liS","active":"SortAdornment_active__u1LRx"};